<template>
  <button
    type="button"
    class="badge cursor-pointer select-none"
    :class="{
      'badge-neutral': isProd,
      'badge-warning': isDev,
      'badge-primary': isStaging,
    }"
    @click="show"
  >
    <FontAwesomeIcon v-if="isDev" :icon="faCode" />
    <FontAwesomeIcon v-else-if="isStaging" :icon="faVial" />
    <span class="hidden md:inline">{{ $t('global.version') }}</span>
    <span>
      <FontAwesomeIcon :icon="faDisplay" />
      {{ clientVersion }}
    </span>
    <span>
      <FontAwesomeIcon :icon="faServer" />
      {{ serverVersion || $t('global.unknown') }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { faCode, faDisplay, faServer, faVial } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';
import { useVersionHistoryDialog } from '../../composables/dialog/useVersionHistoryDialog';
import { useServerStatus } from '../../stores/serverStatusStore';

const { VITE_APP_VERSION: clientVersion, DEV: isDev, PROD: isProd } = import.meta.env;

const { version: serverVersion } = useServerStatus();
const { show } = useVersionHistoryDialog();

const isStaging = computed(() => {
  return !isProd && !isDev;
});
</script>
